import { iconInfoType } from '../types/menu/menu';

//전체메뉴
export const iconInfoList: iconInfoType[] = [
    {
        id: 'nav01',
        value: 'tab1',
        label: '이체',
        icon: '01',
        iconbgtype: 'nav-bgtype-01',
        subMenus: [
            { sublabel: '샘플', subid: 'SAMPLE0021', iconpath: 'subnav1_01', folder: '01' },
            {
                sublabel: '샘플2',
                subid: 'SAMPLE0022',
                iconpath: 'subnav1_02',
                folder: '01',
            },
        ],
    },
];
